export default __webpack_public_path__ + "static/media/BS01.eeb1a81c.jpg";